import React from 'react';
import DbtConnectionList from '../../components/dbt/DbtConnectionList';
import { FeatureGate } from '../../components/billing';

/**
 * DbtConnectionsPage
 * Page displaying all dbt connections
 */
const DbtConnectionsPage = () => {
  return (
    <FeatureGate
      feature="dbt_enabled"
      upgradeMessage="Connect your dbt project to sync models, tests, and sources with Sparvi."
    >
      <div className="container mx-auto px-4 py-6">
        <DbtConnectionList />
      </div>
    </FeatureGate>
  );
};

export default DbtConnectionsPage;
